import styled from 'styled-components';
import { Palette } from 'core/config';
import { FiX } from 'react-icons/fi';

export const Cards = styled.div`
    background-color: ${Palette.MUSTARD};
    border-radius: 1.5rem;
    padding: 3rem 4rem;
    max-width: 30rem;
    width: 100%;
    min-height: 400px;
    position: relative;

    .fade-in {
        opacity: 1;
    }
`;

export const CardsContent = styled.div`
    opacity: 0;
    transition: opacity 0.5s linear 0s;
`;

export const CardsTitle = styled.p`
    font-family: "SofiaPro-Bold";
    font-size: 1.5rem;
    color: ${Palette.BLUE};
    line-height: 2rem;
    margin-top: 0;
`;

export const CardsText = styled.p`
    font-family: 'SofiaPro-Regular';
    font-size: 1rem;
    color: ${Palette.BLUE};
    line-height: 1.5rem;
`;

export const CloseButton = styled(FiX)`
    position: absolute;
    top: 2rem;
    right: 2rem;
    width: 2rem;
    height: 2rem;
    color: ${Palette.BLUE};

    &:hover {
        cursor: pointer;
    }
`;

export const CardsImage = styled.img`
    max-width: 13rem;
    display: block;
    margin: 0 auto;
    margin-top: -1rem;
    transform: translateX(1rem);
`;

